import FacebookButton from '@/next/components/FacebookButton/FacebookButton';

export default FacebookButton;
